













































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import dayjs from "dayjs";
const dashboard = namespace("dashboard");
@Component({})
export default class Template extends Vue {
  @dashboard.Action getNoticeList;
  @dashboard.Action readNotice;
  dayjs = dayjs;
  created() {
    this.init();
  }
  noticeListData: any = [];
  pageNum: number = 1;
  total: number = 0;
  init() {
    this.getNoticeList({
      pageSize: 10,
      pageNum: this.pageNum
    }).then(data => {
      this.total = data.data.total;
      if (data.data.list) {
        this.noticeListData.push(...data.data.list);
      }
    });
  }
  handleRead(row) {
    if (row.readStatus) {
      if (row.site) {
        let site = "";
        try {
          site = JSON.parse(row.site).pc;
        } catch (e) {
          return;
        }
        let { href } = this.$router.resolve({
          path: site
        });
        window.open(href, "_blank");
      }
      return;
    }
    this.readNotice({
      innerMsgCode: row.innerMsgCode
    }).then(data => {
      row.readStatus = 1;
      if (row.site) {
        let site = "";
        try {
          site = JSON.parse(row.site).pc;
        } catch (e) {
          return;
        }
        let { href } = this.$router.resolve({
          path: site
        });
        window.open(href, "_blank");
      }
    });
  }
  handleLoadMore() {
    this.pageNum++;
    this.init();
  }
  handleReadAll() {
    this.readNotice({
      innerMsgCode: null
    }).then(data => {
      this.noticeListData.forEach(item => {
        item.readStatus = 1;
      });
    });
  }
}
